import $ from 'jquery'
import 'jquery-ui';

// Mortgage Calc
var MortgageCalc = {
  _create: function() {
    var self = this;
    var html = self._element_factory();
    $(self.element).html(html);
    console.log(self.element);
    // $(self.element + ':button').on('click', $.proxy(self._event_calculate,self))
    $("#mortgageCalc").on('click', $.proxy(self._event_calculate,self))
  },
  // Hook to create form elements
  _element_factory: function() {
    var output = '';
    var self = this;
    var styles = '';
    //Add Styles First
    if(self.options.add_css) {
      styles += '<style type="text/css">';
      styles += '</style>';
      $('head').append(styles);
    }
    //Add Form Elements
    output += '<div id="mortgagecalc_wrapper" class="calc-table">';
    output += '<div>';
    output += '<label for="price">Mortgage Amount:</label>';
    output += '<input type="text" name="price" id="price" value="' + self.options.price + '">';
    output += '</div>';
    output += '<div>';
    output += '<label for="down_payment">Down Payment:</label>';
    output += '<div><input type="text" name="down_payment" id="down_payment" value="' + self.options.down_payment + '">';
    output += '<span id="dpmt_wrapper">(<span id="down_payment_rate">'  + self._get_down_payment_rate() + '</span>%)</span></div>';
    output += '</div>';
    output += '<div>';
    output += '<label for="interest_rate">Interest Rate:</label>';
    output += '<div><input class="small-input" type="text" name="interest_rate" id="interest_rate" value="' + self.options.interest_rate + '">%</div>';
    output += '</div>'; 
    output += '<div>';
    output += '<label for="loan_term">Term (Years):</label>';
    output += '<input class="small-input" type="text" name="loan_term" id="loan_term" value="' + self.options.loan_term+ '">';
    output += '</div>'; 
    output += '<div>';
    output += '<label for="monthly_payment">Monthly Payment:</label>'; 
    output += '<p>$<span id="monthly_payment">' + self._get_monthly_payment() + '</span></p>'; 
    output += '</div>';
    output += '<div class="button_wrapper">';
    output += '<button type="button" name="calculate" value="Calculate" id="mortgageCalc" class="calc-btn">Calculate</button>';
    output += '</div>';
    output += '</div>';
    return output;
  },
  _get_monthly_payment: function() {
    var PR = this._get_val('price') - this._get_val('down_payment');
    var IN = (this._get_val('interest_rate') * 0.01) / 12;
    var PE = this._get_val('loan_term') * 12;
    var payment = (PR * IN) / (1 - Math.pow(1 + IN, -PE))
    payment = this._round_number(payment,2); 
    return payment;
  },
  _get_val: function(val) {
    var _v = parseFloat($(this.element).find('input[name=' + val + ']').val());
    if(!isNaN(_v)) {
      return _v;
    }
    if(!isNaN(parseFloat(this.options[val]))) {
      return parseFloat(this.options[val]);
    }
    return 0;
  },
  _get_down_payment_rate: function() {
    var price = this._get_val('price');
    var dpmt = this._get_val('down_payment');
    return this._round_number((dpmt/price) * 100,2);
  },
  _round_number: function(value,decimal_len) {
    return Math.round(value * Math.pow(10,decimal_len))/Math.pow(10,decimal_len);
  },
  _event_calculate: function() {
    $(this.element).find('#down_payment_rate').html(this._get_down_payment_rate());
    $(this.element).find('#monthly_payment').html(this._get_monthly_payment()); 
  },
  options: {
    price: 0,
    down_payment: 0,
    loan_term: 30,
    interest_rate: 4.25,
    add_css: true
  }
};

function initLoanCalculator(){
  !function(a,b){a.extend(a.fn,{accrue:function(b){return b=a.extend({calculationMethod:d},a.fn.accrue.options,b),this.each(function(){var g=a(this);g.find(".form").length||g.append('<div class="form"></div>');c(g,b,"amount"),c(g,b,"rate"),c(g,b,"term");if("compare"==b.mode){c(g,b,"rate_compare")}var h;".results"===b.response_output_div?(0===g.find(".results").length&&g.append('<div class="results"></div>'),h=g.find(".results")):h=a(b.response_output_div);var i;switch(b.mode){case"basic":i=d;break;case"compare":i=e;break;case"amortization":i=f}i(g,b,h),"button"==b.operation?(0===g.find("button").length&&g.find(".form").append('<button class="accrue-calculate">'+b.button_label+"</button>"),g.find("button, input[type=submit]").each(function(){a(this).click(function(a){a.preventDefault(),i(g,b,h)})})):g.find("input, select").each(function(){a(this).bind("keyup change",function(){i(g,b,h)})}),g.find("form").each(function(){a(this).submit(function(a){a.preventDefault(),i(g,b,h)})})})}}),a.fn.accrue.options={mode:"basic",operation:"keyup",default_values:{amount:"$7,500",rate:"7%",rate_compare:"1.49%",term:"36m"},field_titles:{amount:"Loan Amount",rate:"Rate (APR)",rate_compare:"Comparison Rate",term:"Term"},button_label:"Calculate",field_comments:{amount:"",rate:"",rate_compare:"",term:"Format: 12m, 36m, 3y, 7y"},response_output_div:".results",response_basic:"<p><strong>Monthly Payment:</strong><br />$%payment_amount%</p><p><strong>Number of Payments:</strong><br />%num_payments%</p><p><strong>Total Payments:</strong><br />$%total_payments%</p><p><strong>Total Interest:</strong><br />$%total_interest%</p>",response_compare:"Save $%savings% in interest!",error_text:"Please fill in all fields.",callback:function(){}};var c=function(a,b,c){var d;return a.find(".accrue-"+c).length?d=a.find(".accrue-"+c):a.find("."+c).length?d=a.find("."+c):a.find("input[name~="+c+"]").length?a.find("input[name~="+c+"]"):d="","string"!=typeof d?d.val():"term_compare"==c?!1:(a.find(".form").append('<div class="accrue-field-'+c+'"><p><label for="'+c+'">'+b.field_titles[c]+':</label><input type="text" class="'+c+'" id="'+c+'" value="'+b.default_values[c]+'" />'+(b.field_comments[c].length>0?"<small>"+b.field_comments[c]+"</small>":"")+"</p></div>"),a.find("."+c).val())},d=function(b,d,e){var f=a.loanInfo({amount:c(b,d,"amount"),rate:c(b,d,"rate"),term:c(b,d,"term")});if(0!==f){var g=d.response_basic.replace("%payment_amount%",f.payment_amount_formatted).replace("%num_payments%",f.num_payments).replace("%total_payments%",f.total_payments_formatted).replace("%total_interest%",f.total_interest_formatted);e.html(g)}else e.html('<p class="error">'+d.error_text+"</p>");d.callback(b,f)},e=function(b,d,e){var f=c(b,d,"term_compare");"boolean"==typeof f&&(f=c(b,d,"term"));var g=a.loanInfo({amount:c(b,d,"amount"),rate:c(b,d,"rate"),term:c(b,d,"term")}),h=a.loanInfo({amount:c(b,d,"amount"),rate:c(b,d,"rate_compare"),term:f}),i={loan_1:g,loan_2:h};if(0!==g&&0!==h){i.savings=g.total_interest-h.total_interest>0?g.total_interest-h.total_interest:0;var j=d.response_compare.replace("%savings%",i.savings.toFixed(2)).replace("%loan_1_payment_amount%",h.payment_amount_formatted).replace("%loan_1_num_payments%",h.num_payments).replace("%loan_1_total_payments%",h.total_payments_formatted).replace("%loan_1_total_interest%",h.total_interest_formatted).replace("%loan_2_payment_amount%",g.payment_amount_formatted).replace("%loan_2_num_payments%",g.num_payments).replace("%loan_2_total_payments%",g.total_payments_formatted).replace("%loan_2_total_interest%",g.total_interest_formatted);e.html('<p class="total-savings">'+j+"</p>")}else e.html('<p class="error">'+d.error_text+"</p>");d.callback(b,i)},f=function(b,d,e){var f=a.loanInfo({amount:c(b,d,"amount"),rate:c(b,d,"rate"),term:c(b,d,"term")});if(0!==f){for(var g='<table class="accrue-amortization"><tr><th class="accrue-payment-number">#</th><th class="accrue-payment-amount">Payment Amt.</th><th class="accrue-total-interest">Total Interest</th><th class="accrue-total-payments">Total Payments</th><th class="accrue-balance">Balance</th></tr>',h=f.payment_amount-f.original_amount/f.num_payments,i=f.payment_amount-h,j=0,k=0,l=parseInt(f.original_amount),m=0;m<f.num_payments;m++){j+=h,k+=f.payment_amount,l-=i;var n="td";m==f.num_payments-1&&(n="th"),g=g+"<tr><"+n+' class="accrue-payment-number">'+(m+1)+"</"+n+"><"+n+' class="accrue-payment-amount">$'+f.payment_amount_formatted+"</"+n+"><"+n+' class="accrue-total-interest">$'+j.toFixed(2)+"</"+n+"><"+n+' class="accrue-total-payments">$'+k.toFixed(2)+"</"+n+"><"+n+' class="accrue-balance">$'+l.toFixed(2)+"</"+n+"></tr>"}g+="</table>",e.html(g)}else e.html('<p class="error">'+d.error_text+"</p>");d.callback(b,f)};a.loanInfo=function(a){var b=("undefined"!=typeof a.amount?a.amount:0).replace(/[^\d.]/gi,""),c=("undefined"!=typeof a.rate?a.rate:0).replace(/[^\d.]/gi,""),d="undefined"!=typeof a.term?a.term:0;d=d.match("y")?12*parseInt(d.replace(/[^\d.]/gi,"")):parseInt(d.replace(/[^\d.]/gi,""));var e=c/100/12,f=Math.pow(1+e,d),g=b*f*e/(f-1);return b*c*d>0?{original_amount:b,payment_amount:g,payment_amount_formatted:g.toFixed(2),num_payments:d,total_payments:g*d,total_payments_formatted:(g*d).toFixed(2),total_interest:g*d-b,total_interest_formatted:(g*d-b).toFixed(2)}:0}}(jQuery,window,document);
}

function initSavingsCalculator(){
  var i = 0; // interest
  var m = 0; // months
  var f = 0; // factor
  var den = 0;
  var s = "0"; // string
  var d = 0; // decimal place
  if(document.calform.interest.value=="" || document.calform.months.value=="" || document.calform.payment.value=="") {
    alert("Please fill in all of the required fields.");
  }
  else {
    if(document.calform.period.options[1].selected == true) {
      m = document.calform.months.value * 12;
    }
    else {
      m = document.calform.months.value;
    }
    i = Math.pow(((document.calform.interest.value/100)+1),.0833333)-1;
    den = i / (i+1);
    f = Math.pow((i+1),m)-1;
    f /= den;
    f *= document.calform.payment.value;
    d = String(f).indexOf(".");
    s = String(f).substring(0,(d+3));
    document.calform.total.value = "$" + s;
  }
}

$(document).ready(function () {
  if($(".mcalc").length){
    $.widget('ui.mortgagecalc', MortgageCalc);
    var params = {
      price: '300000',
      down_payment: '30000'
    }
    $('.mcalc').mortgagecalc(params);
  }

  if($(".loan-calculator").length){
    initLoanCalculator();
    $(function() {
      $(".loan-calculator").accrue();
    });
  }

  if($(".savings-calculator")){
    $("#savingsBtnCalc").on('click', initSavingsCalculator )
  }
});
